document.addEventListener("DOMContentLoaded", () => {
  clearFormInputs();
  initValidation();
  initTextareaAutoResize();
  initToggleForms();
  initShowAllButton();
});

function clearFormInputs() {
  document
    .querySelectorAll(".offers input, .offers textarea")
    .forEach((input) => {
      if (input.type === "checkbox" || input.type === "radio") {
        input.checked = false;
      } else {
        input.value = "";
      }
    });
}

function initValidation() {
  const checkboxes = document.querySelectorAll(".checkbox");
  checkboxes.forEach((checkbox) =>
    checkbox.addEventListener("change", validateRequiredFields),
  );
  validateRequiredFields();
}

function validateRequiredFields() {
  document.querySelectorAll(".row").forEach((row) => {
    const checkbox = row.querySelector(".checkbox");
    const priceInput = row.querySelector(".price-input");

    if (checkbox && priceInput) {
      if (priceInput.type !== "hidden") {
        priceInput.toggleAttribute("required", checkbox.checked);
      }
    }
  });
}

function initTextareaAutoResize() {
  const handleInput = (event) => {
    if (!event.target.matches('textarea[name="comment"]')) return;

    const textarea = event.target;
    textarea.rows = 1;

    const lineHeight = parseInt(
      window.getComputedStyle(textarea).lineHeight,
      10,
    );
    textarea.rows = Math.ceil(textarea.scrollHeight / lineHeight);

    const formWrapper = textarea.closest(".offers__panel-content");
    if (formWrapper) {
      const form = formWrapper.querySelector(".form");
      if (form) {
        formWrapper.style.maxHeight = `${form.clientHeight}px`;
      }
    }
  };

  document.addEventListener("input", handleInput);
  window.addEventListener("beforeunload", () => {
    document.removeEventListener("input", handleInput);
  });
}

function initToggleForms() {
  document.querySelectorAll(".offers__panel-title").forEach((title) => {
    const formWrapper = title.nextElementSibling;
    const form = formWrapper?.querySelector(".form");
    const arrow = title.querySelector(".arrow");

    const handleToggle = () => {
      const isOpen = formWrapper.classList.toggle("open");
      formWrapper.style.maxHeight = isOpen ? `${form.clientHeight}px` : "0";
      arrow.classList.toggle("rotated", isOpen);
    };

    title.addEventListener("click", handleToggle);

    window.addEventListener("beforeunload", () => {
      title.removeEventListener("click", handleToggle);
    });
  });
}

function initShowAllButton() {
  const hiddenRows = document.querySelectorAll(".substances .row.hidden");
  const button = document.querySelector(".substances .button");

  button.addEventListener("click", () => {
    hiddenRows.forEach((row) => row.classList.remove("hidden"));
    button.style.display = "none";
  });
}
